import { useTranslation } from "react-i18next";

import { PlusPromo } from "../../../../components/PlusPromo";

type Props = {
  onClick: () => void;
};

/** A paid PLUS subscription waiting for its Keepo (never published): same block as the other PLUS banners. */
export const ActiveSubscriptionBanner = ({ onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <PlusPromo
      compact
      title={t("pages.sites.components.pendingPremiumBanner.title")}
      description={t("pages.sites.components.pendingPremiumBanner.subtitle")}
      cta={t("pages.sites.components.pendingPremiumBanner.ctaButton")}
      onClick={onClick}
    />
  );
};
